import React,{useState} from 'react'
import {GiWeightLiftingUp} from "react-icons/gi"
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const App = () => {
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [bmiResult, setBmiResult] = useState("");
  const [status, setStatus] = useState("");



  const calculateBMI = () => {
    let bmi = Number(weight / (height / 100) ** 2).toFixed(2);
    setBmiResult(bmi);
    // let bmiStatus = getStatus(bmi);
    setStatus(getStatus(bmi));
  }

  const getStatus = (bmi) => {

    if(bmi<18.5){
      return "under weight";
    }else if(bmi>=18.5 && bmi<24.9){
      return "healthy";
    }else if(bmi>=25 && bmi<29.9){
      return "over weight";
    }else{
      return "obese";
    }

  }


    

  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <GiWeightLiftingUp className='mx-auto w-auto text-indigo-600 text-4xl'/>
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            
              {'Calculate your BMI' || <Skeleton />}
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Or{' '}
              <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                {"Register Now" || <Skeleton />}
              </a>
            </p>
          </div>
          <form className="mt-8 space-y-6" action="#" method="POST">
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="height"
                  type="text"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="height in cm"
                  pattern="[0-9]"
                  value={height}
                  onChange={e=>setHeight(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="weight"
                  type="text"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="weight in kg"
                  value={weight}
                  onChange={e=>setWeight(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={calculateBMI}
              >
                Calculate
              </button>

                {/* <p>{height}</p> */}
                {/* <button type="button" className='bg-indigo-600' onClick={()=>setHeight(height*2)}>increment</button> */}
              {bmiResult && 
                <div className='mt-4 text-sm'>
                <p>Current height is {height || <Skeleton />}cm, Current weight is {weight || <Skeleton />}kg</p>
                <p>Your BMI is: {bmiResult || <Skeleton />}</p>
                <p>You are {status || <Skeleton />}</p>
              </div>
              }

            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default App